import { isTestNet } from "./web3_api";
import PanSeaCollectionFactory from "./abis/PanSeaCollectionFactory.json";
import PanSeaERC1155Collection from "./abis/PanSeaERC1155Collection.json";
import PanSeaERC721Collection from "./abis/PanSeaERC721Collection.json";
import PanSeaERC721Drop from "./abis/PanSeaERC721Drop.json";
import PanSeaMarketplace from "./abis/PanSeaMarketplace.json";
import TestUSD from "./abis/TestUSD.json";
import MaalValidatorNFT from "./abis/MaalValidatorNFT.json";

const network = isTestNet();
console.log("Is test network: ", network);

// PanSea v2 suite (pansea-new-contracts). The factory and marketplace have the same address on
// MaalChain V2 mainnet (7862) and Testnet V2 (7863): pansea-new-contracts/deployments/maalchain-*.json.
export const factory_Address = "0x245f3717d891af84D33Dbe1af291B479d72142F0";

export const factory_ABI = PanSeaCollectionFactory;

/** `PanSeaCollectionFactory.Kind` */
export const COLLECTION_KIND = { ERC721: 1, ERC721Drop: 2, ERC1155: 3 };

export const nft_Minting_ABI_1156 = PanSeaERC1155Collection;

export const nft_Minting_ABI_721 = PanSeaERC721Collection;

/**
 * For reading any NFT contract on display pages: the v2 ERC721 ABI plus the
 * legacy `baseURI()` view that the validator NFT (out of scope, unchanged)
 * builds its metadata URL from.
 */
export const nft_Display_ABI_721 = [
  ...PanSeaERC721Collection,
  { type: "function", name: "baseURI", inputs: [], outputs: [{ type: "string", name: "" }], stateMutability: "view" },
];

export const market_Place_Address = "0x1DCD6aEAd7d6fFC8f6321B6aBCaa484f6A8AE96C";

export const market_Place_Abi = PanSeaMarketplace;

export const BUSD_Address = "0x4169e624bB7200C00E55Ed526929bfE78B5348A6";
export const BUSD_Abi = [
  {
    type: "constructor",
    inputs: [
      { type: "string", name: "_name", internalType: "string" },
      { type: "string", name: "_symbol", internalType: "string" },
      { type: "string", name: "_currency", internalType: "string" },
      { type: "uint8", name: "_decimals", internalType: "uint8" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "allowance",
    inputs: [
      { type: "address", name: "owner", internalType: "address" },
      { type: "address", name: "spender", internalType: "address" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "approve",
    inputs: [
      { type: "address", name: "spender", internalType: "address" },
      { type: "uint256", name: "value", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "balanceOf",
    inputs: [{ type: "address", name: "account", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "blacklist",
    inputs: [{ type: "address", name: "_account", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "address", name: "", internalType: "address" }],
    name: "blacklister",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "burn",
    inputs: [{ type: "uint256", name: "_amount", internalType: "uint256" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "configureMinter",
    inputs: [
      { type: "address", name: "minter", internalType: "address" },
      { type: "uint256", name: "minterAllowedAmount", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "currency",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint8", name: "", internalType: "uint8" }],
    name: "decimals",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "initialize",
    inputs: [
      { type: "address", name: "newMasterMinter", internalType: "address" },
      { type: "address", name: "newPauser", internalType: "address" },
      { type: "address", name: "newBlacklister", internalType: "address" },
      { type: "address", name: "newOwner", internalType: "address" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "isBlacklisted",
    inputs: [{ type: "address", name: "_account", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "isMinter",
    inputs: [{ type: "address", name: "account", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "address", name: "", internalType: "address" }],
    name: "masterMinter",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "mint",
    inputs: [
      { type: "address", name: "_to", internalType: "address" },
      { type: "uint256", name: "_amount", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "mintByMaster",
    inputs: [
      { type: "address", name: "_to", internalType: "address" },
      { type: "uint256", name: "_amount", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "minterAllowance",
    inputs: [{ type: "address", name: "minter", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "name",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "address", name: "", internalType: "address" }],
    name: "owner",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "paused",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "address", name: "", internalType: "address" }],
    name: "pauser",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "removeMinter",
    inputs: [{ type: "address", name: "minter", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "renounceOwnership",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "rescueMAAL20",
    inputs: [
      {
        type: "address",
        name: "tokenContract",
        internalType: "contract IMAAL20",
      },
      { type: "address", name: "to", internalType: "address" },
      { type: "uint256", name: "amount", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "address", name: "", internalType: "address" }],
    name: "rescuer",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "symbol",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "totalSupply",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "transfer",
    inputs: [
      { type: "address", name: "to", internalType: "address" },
      { type: "uint256", name: "value", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "transferFrom",
    inputs: [
      { type: "address", name: "from", internalType: "address" },
      { type: "address", name: "to", internalType: "address" },
      { type: "uint256", name: "value", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "transferOwnership",
    inputs: [{ type: "address", name: "newOwner", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "unBlacklist",
    inputs: [{ type: "address", name: "_account", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "updateBlacklister",
    inputs: [
      { type: "address", name: "_newBlacklister", internalType: "address" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "updateMasterMinter",
    inputs: [
      { type: "address", name: "_newMasterMinter", internalType: "address" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "updateRescuer",
    inputs: [{ type: "address", name: "newRescuer", internalType: "address" }],
  },
  {
    type: "event",
    name: "Approval",
    inputs: [
      { type: "address", name: "owner", indexed: true },
      { type: "address", name: "spender", indexed: true },
      { type: "uint256", name: "value", indexed: false },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Blacklisted",
    inputs: [{ type: "address", name: "_account", indexed: true }],
    anonymous: false,
  },
  {
    type: "event",
    name: "BlacklisterChanged",
    inputs: [{ type: "address", name: "newBlacklister", indexed: true }],
    anonymous: false,
  },
  {
    type: "event",
    name: "Burn",
    inputs: [
      { type: "address", name: "burner", indexed: true },
      { type: "uint256", name: "amount", indexed: false },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "MasterMinterChanged",
    inputs: [{ type: "address", name: "newMasterMinter", indexed: true }],
    anonymous: false,
  },
  {
    type: "event",
    name: "Mint",
    inputs: [
      { type: "address", name: "minter", indexed: true },
      { type: "address", name: "to", indexed: true },
      { type: "uint256", name: "amount", indexed: false },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "MintByMaster",
    inputs: [
      { type: "address", name: "masterMinter", indexed: true },
      { type: "address", name: "to", indexed: true },
      { type: "uint256", name: "amount", indexed: false },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "MinterConfigured",
    inputs: [
      { type: "address", name: "minter", indexed: true },
      { type: "uint256", name: "minterAllowedAmount", indexed: false },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "MinterRemoved",
    inputs: [{ type: "address", name: "oldMinter", indexed: true }],
    anonymous: false,
  },
  {
    type: "event",
    name: "OwnershipTransferred",
    inputs: [
      { type: "address", name: "previousOwner", indexed: true },
      { type: "address", name: "newOwner", indexed: true },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Paused",
    inputs: [{ type: "address", name: "account", indexed: false }],
    anonymous: false,
  },
  {
    type: "event",
    name: "PauserChanged",
    inputs: [{ type: "address", name: "newAddress", indexed: true }],
    anonymous: false,
  },
  {
    type: "event",
    name: "RescuerChanged",
    inputs: [{ type: "address", name: "newRescuer", indexed: true }],
    anonymous: false,
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      { type: "address", name: "from", indexed: true },
      { type: "address", name: "to", indexed: true },
      { type: "uint256", name: "value", indexed: false },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "UnBlacklisted",
    inputs: [{ type: "address", name: "_account", indexed: true }],
    anonymous: false,
  },
  {
    type: "event",
    name: "Unpaused",
    inputs: [{ type: "address", name: "account", indexed: false }],
    anonymous: false,
  },
];

// MAALChain Validator NFT (MVNFT), minted by its owner through `mintByApproved`. Mainnet only.
export const NFT_Validator_Address = network ? undefined : "0x5D49973886b653Da2b7395a118699f6A12c66555";
export const NFT_Validator_ABI = MaalValidatorNFT;

export const AirDropNFT_Address = network
  ? "0xb89aA93c4ffF25461f5fAC88fd1bD6372f623Fe2"
  : "0x31c015774A0fb5E52561b6275c5f3E1Edd235dbB"; // mainnet  0x31c015774A0fb5E52561b6275c5f3E1Edd235dbB    // testnet  0xb89aA93c4ffF25461f5fAC88fd1bD6372f623Fe2

export const AirDropNFT_ABI = [
  {
    type: "constructor",
    stateMutability: "nonpayable",
    inputs: [
      { type: "string", name: "name_", internalType: "string" },
      { type: "string", name: "symbol_", internalType: "string" },
      { type: "string", name: "baseURI_", internalType: "string" },
    ],
  },
  {
    type: "event",
    name: "Approval",
    inputs: [
      {
        type: "address",
        name: "owner",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "approved",
        internalType: "address",
        indexed: true,
      },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ApprovalForAll",
    inputs: [
      {
        type: "address",
        name: "owner",
        internalType: "address",
        indexed: true,
      },
      {
        type: "address",
        name: "operator",
        internalType: "address",
        indexed: true,
      },
      { type: "bool", name: "approved", internalType: "bool", indexed: false },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Transfer",
    inputs: [
      { type: "address", name: "from", internalType: "address", indexed: true },
      { type: "address", name: "to", internalType: "address", indexed: true },
      {
        type: "uint256",
        name: "tokenId",
        internalType: "uint256",
        indexed: true,
      },
    ],
    anonymous: false,
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "address", name: "", internalType: "address" }],
    name: "_owner",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "approve",
    inputs: [
      { type: "address", name: "to", internalType: "address" },
      { type: "uint256", name: "tokenId", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "approveForMinting",
    inputs: [
      { type: "address", name: "_minter", internalType: "address" },
      { type: "bool", name: "status", internalType: "bool" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "balanceOf",
    inputs: [{ type: "address", name: "owner", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "baseURI",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "batchmintByOwner",
    inputs: [
      { type: "address", name: "account", internalType: "address" },
      { type: "uint256[]", name: "tokenId", internalType: "uint256[]" },
    ],
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [],
    name: "batchmintPublic",
    inputs: [{ type: "uint256[]", name: "tokenId", internalType: "uint256[]" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "bulkMintByOwner",
    inputs: [
      { type: "address", name: "account", internalType: "address" },
      { type: "uint256", name: "startingTokenId", internalType: "uint256" },
      { type: "uint256", name: "totalAmount", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "cost",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "address", name: "", internalType: "address" }],
    name: "getApproved",
    inputs: [{ type: "uint256", name: "tokenId", internalType: "uint256" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "isApprovedForAll",
    inputs: [
      { type: "address", name: "owner", internalType: "address" },
      { type: "address", name: "operator", internalType: "address" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "maxMintAmountPerTx",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "maxSupply",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "mint",
    inputs: [
      { type: "address", name: "account", internalType: "address" },
      { type: "uint256", name: "tokenId", internalType: "uint256" },
      { type: "bytes", name: "data", internalType: "bytes" },
    ],
  },
  {
    type: "function",
    stateMutability: "payable",
    outputs: [],
    name: "mintPublic",
    inputs: [{ type: "uint256", name: "tokenId", internalType: "uint256" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "name",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "address", name: "", internalType: "address" }],
    name: "ownerOf",
    inputs: [{ type: "uint256", name: "tokenId", internalType: "uint256" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "paused",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "recoverMAAL",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "safeTransferFrom",
    inputs: [
      { type: "address", name: "from", internalType: "address" },
      { type: "address", name: "to", internalType: "address" },
      { type: "uint256", name: "tokenId", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "safeTransferFrom",
    inputs: [
      { type: "address", name: "from", internalType: "address" },
      { type: "address", name: "to", internalType: "address" },
      { type: "uint256", name: "tokenId", internalType: "uint256" },
      { type: "bytes", name: "_data", internalType: "bytes" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "setApprovalForAll",
    inputs: [
      { type: "address", name: "operator", internalType: "address" },
      { type: "bool", name: "approved", internalType: "bool" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "setBaseURI",
    inputs: [{ type: "string", name: "baseURI_", internalType: "string" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "setName",
    inputs: [{ type: "string", name: "name_", internalType: "string" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "setOwner",
    inputs: [{ type: "address", name: "newOwner", internalType: "address" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "setSymbol",
    inputs: [{ type: "string", name: "symbol_", internalType: "string" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "bool", name: "", internalType: "bool" }],
    name: "supportsInterface",
    inputs: [{ type: "bytes4", name: "interfaceId", internalType: "bytes4" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "symbol",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "toggleMinting",
    inputs: [{ type: "bool", name: "status", internalType: "bool" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "tokenByIndex",
    inputs: [{ type: "uint256", name: "index", internalType: "uint256" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "tokenOfOwnerByIndex",
    inputs: [
      { type: "address", name: "owner", internalType: "address" },
      { type: "uint256", name: "index", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "tokenURI",
    inputs: [{ type: "uint256", name: "_tokenId", internalType: "uint256" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "uint256", name: "", internalType: "uint256" }],
    name: "totalSupply",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "transferFrom",
    inputs: [
      { type: "address", name: "from", internalType: "address" },
      { type: "address", name: "to", internalType: "address" },
      { type: "uint256", name: "tokenId", internalType: "uint256" },
    ],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "updateCost",
    inputs: [{ type: "uint256", name: "_newCost", internalType: "uint256" }],
  },
  {
    type: "function",
    stateMutability: "nonpayable",
    outputs: [],
    name: "updateMaxMintPerTx",
    inputs: [{ type: "uint256", name: "_val", internalType: "uint256" }],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "uriPrefix",
    inputs: [],
  },
  {
    type: "function",
    stateMutability: "view",
    outputs: [{ type: "string", name: "", internalType: "string" }],
    name: "uriSuffix",
    inputs: [],
  },
];

export const AirDropNFT_ABIv2 = PanSeaERC721Drop;

/** Testnet only: PanSea Test USD, the faucet ERC-20 allowlisted on the v2 marketplace. */
export const TestUSD_Address = network ? "0x74857AEBBA3bbb0E8b4050c861F0f265f2951B49" : undefined;
export const TestUSD_ABI = TestUSD;

// Payment tokens the v2 testnet marketplace accepts (allowedCurrency): MAAL and tUSD.
export const TOKENS = [
  {
    address: "0x0000000000000000000000000000000000000000",
    name: "MAAL",
    symbol: "MAAL",
    logo: "https://ipfs.io/ipfs/QmXCRTnM7N8HefWCJjpBkio4z1wA6J5SS6921mKtzBV4hv?filename=favicon.png",
    decimal: 18,
  },
  {
    address: "0x74857AEBBA3bbb0E8b4050c861F0f265f2951B49",
    name: "PanSea Test USD",
    symbol: "tUSD",
    logo: "https://cryptologos.cc/logos/tether-usdt-logo.png?v=026",
    decimal: 18,
  },
];

// The v2 mainnet marketplace accepts only MAAL until its owner allowlists an ERC-20
// (setCurrencyAllowed). The legacy XAUS token is not deployed on MaalChain V2.
export const MAINNETTOKENS = network
  ? TOKENS
  : [
      {
        address: "0x0000000000000000000000000000000000000000",
        name: "MAAL",
        symbol: "MAAL",
        logo: "https://ipfs.io/ipfs/QmXCRTnM7N8HefWCJjpBkio4z1wA6J5SS6921mKtzBV4hv?filename=favicon.png",
        decimal: 18,
      },
    ];
